import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextField, Box, Typography } from "@mui/material";
import FirstNameField from "./components/first_name";
import LastNameField from "./components/last_name";
import GenderField from "./components/gender";
import ShortTextField from "./components/text";
import DOBField from "./components/dob";
import SelectField from "./components/select";
import BVNField from "./components/bvn";
import SelfieField from "./components/selfie";
import ImageField from "./components/image";
import FileField from "./components/file";
import DocumentField from "./components/document";
import ParagraphField from "./components/paragraph";
import SignaturePadField from "./components/signature_pad";
import NINField from "./components/nin";
import NumberField from "./components/number";
import GoogleAddressField from "./components/google_address";
import EmailAddressField from "./components/email_address";
import PhoneNumberField from "./components/phone_number";
import PasswordField from "./components/password";
import CurrentGPSLocation from "./components/gps_location";
import GeoLocationMapPoint from "./components/geo_point";
import DateField from "./components/date";
import MultiSelectField from "./components/multi_select";
import VideoRecorder from "./components/video";
import AudioRecorder from "./components/audio";
import RelatedDropDownsField from "./components/related_dropdowns";
import AmountField from "./components/amount";
import CalculatedValueField from "./components/calculated_value";
import DecimalField from "./components/decimal";
import GPSPerimeter from "./components/gps_perimeter";
import HumanFaceField from "./components/human_face";
import RelatedDropDown from "./components/related_dropdown";
import FormulaValueField from "./components/formula_field";
import QRScannerField from "./components/qr_code";
import BarcodeReaderField from "./components/barcode_reader";
import GeoTaggedImageField from "./components/geotag_image";
import GeoTaggedImageUploadField from "./components/geotagged_image_upload";
import CheckboxField from "./components/checkbox";
import RadioButtonGroupField from "./components/radio_button_group";
import MultiCheckboxField from "./components/multi_checkbox";
import PaymentField from "./components/payment_field";

function FormSectionBuilder({ section, logic }) {
  const [sectionFields, setSectionFields] = useState([]);

  function buildSectionField(field) {
    let component = null;

    if (field.child !== null && field.data_field.related_field) {
      const rOpts = field.options;
      return (
        <RelatedDropDownsField
          displayNameParent={field.display_name}
          displayNameChild={field.child.display_name}
          fieldRefParent={field.reference}
          fieldRefChild={field.child.reference}
          relatedOptions={rOpts}
        />
      );
    }

    if (field.parent !== null && field.type === "related_dropdown") {
      return (
        <RelatedDropDown
          displayName={field.display_name}
          name={field.code}
          fieldRef={field.reference}
          parentRef={field.parent.reference}
          options={field.options}
        />
      );
    }

    switch (field.type) {
      case "first_name":
        component = (
          <FirstNameField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "last_name":
        component = (
          <LastNameField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gender":
        component = (
          <GenderField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "dob":
        component = (
          <DOBField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "date":
        component = (
          <DateField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "bvn":
        component = (
          <BVNField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "nin":
        component = (
          <NINField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "selfie":
        component = (
          <SelfieField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "image":
        component = (
          <ImageField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "file":
        component = (
          <FileField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "document":
        component = (
          <DocumentField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "signature":
        component = (
          <SignaturePadField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "text":
        component = (
          <ShortTextField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "number":
        component = (
          <NumberField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "paragraph":
        component = (
          <ParagraphField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "google_address":
        component = (
          <GoogleAddressField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "email_address":
        component = (
          <EmailAddressField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "phone_number":
        component = (
          <PhoneNumberField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "select":
        component = (
          <SelectField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
            editable={field.editable}
          />
        );
        break;
      case "password":
        component = (
          <PasswordField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gps_location":
        component = (
          <CurrentGPSLocation
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geo_point":
        component = (
          <GeoLocationMapPoint
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "multi_select":
        component = (
          <MultiSelectField
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "audio":
        component = (
          <AudioRecorder
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "video":
        component = (
          <VideoRecorder
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "amount":
        component = (
          <AmountField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "calculated_value":
        component = (
          <CalculatedValueField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "decimal":
        component = (
          <DecimalField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gps_perimeter":
        component = (
          <GPSPerimeter
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "human_face":
        component = (
          <HumanFaceField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "formula_field":
        component = (
          <FormulaValueField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "qr_code_scanner":
        component = (
          <QRScannerField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "barcode_reader":
        component = (
          <BarcodeReaderField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geotag_image":
        component = (
          <GeoTaggedImageField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geotagged_image_upload":
        component = (
          <GeoTaggedImageUploadField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "checkbox":
        component = (
          <CheckboxField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "multi_checkbox":
        component = (
          <MultiCheckboxField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "radio_button_group":
        component = (
          <RadioButtonGroupField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "payment_field":
        component = (
          <PaymentField
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      default:
        component = (
          <TextField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
    }

    return component;
  }

  useEffect(() => {
    const fields = [];
    section.fields.map((param) => {
      fields.push(param);
      return false;
    });
    // console.log(fields);
    setSectionFields(fields);
  }, [section]);

  return (
    <Box>
      <Box>
        <Typography variant="caption" fontWeight="bold">
          {section.title.toUpperCase()}
        </Typography>
      </Box>
      {section.description !== null && (
        <Box>
          <Typography variant="caption" fontWeight="light">
            {section.description}
          </Typography>
        </Box>
      )}

      {/* {sectionFields.map((field) => (
        <Box mt={2} mb={3}>
          {field}
        </Box>
      ))} */}
      {sectionFields.length > 0 && (
        <>
          {sectionFields.map((param) => {
            let field = <></>;
            if (param.reference in logic.listeners) {
              const listener = logic.listeners[param.reference];
              let wID = `t_watcher_${listener.type}_${param.reference}`;
              field = (
                <div id={`${wID}`} style={{ display: "none" }}>
                  {buildSectionField(param)}
                </div>
              );
              setTimeout(async () => {
                const parentField = document.getElementById(
                  `dff_${listener.trigger}`,
                );
                parentField.addEventListener("change", function () {
                  const d = document.getElementById(wID);
                  if (parentField.value !== listener.control) {
                    d.style.display = "none";
                    document.getElementById(`dff_${param.reference}`).value =
                      null;
                  } else {
                    d.style.display = "block";
                  }
                });
              }, 1000);
            } else {
              field = buildSectionField(param);
            }
            return (
              <Box mt={2} mb={3}>
                {field}
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
}
// Typechecking props of the Transaction
FormSectionBuilder.propTypes = {
  section: PropTypes.isRequired,
  logic: PropTypes.any,
};
export default FormSectionBuilder;
